import styled from 'styled-components'
import { tabletBreakpoint } from 'react-components'

export const StyledTitleBar = styled.div`
    display: flex;
    flex: 1;
    padding: ${({ theme }) => `0 0 ${theme.spacing.xxSmall}`};
    @media (min-width: ${tabletBreakpoint.min}px) {
        align-items: center;
        padding: ${({ theme }) => `${theme.spacing.xxSmall} 0`};
    }
`
